module.exports = __webpack_public_path__ + "static/media/ico_simulation_face_nasolabial.90767c58.png";